/** Static analytics demo data aligned with the Practice Insights design */

export const analyticsRevenueByMonth = [
  { month: 'Aug', value: 4200 },
  { month: 'Sep', value: 4800 },
  { month: 'Oct', value: 4500 },
  { month: 'Nov', value: 5200 },
  { month: 'Dec', value: 5600 },
  { month: 'Jan', value: 6420 },
];

export type PaymentRowStatus = 'paid' | 'pending';

export interface AnalyticsPaymentRow {
  name: string;
  service: string;
  amount: string;
  status: PaymentRowStatus;
  statusDetail?: string;
}

export const analyticsRecentPayments: AnalyticsPaymentRow[] = [
  { name: 'Sarah Mitchell', service: 'Progress Review', amount: '$120', status: 'paid', statusDetail: 'Paid · Jan 18' },
  { name: 'James Okafor', service: 'Initial Consultation', amount: '$200', status: 'paid', statusDetail: 'Paid · Jan 17' },
  { name: 'Daniel Torres', service: 'Monthly Check-in', amount: '$95', status: 'pending' },
  { name: 'Mei Lin', service: 'Follow-up Session', amount: '$150', status: 'paid', statusDetail: 'Paid · Jan 15' },
];

export interface AnalyticsConditionBar {
  label: string;
  count: number;
  color: string;
}

export const analyticsClientConditions: AnalyticsConditionBar[] = [
  { label: 'Type 2 Diabetes', count: 16, color: '#ffa2a2' },
  { label: 'Thyroid', count: 11, color: '#ff9f43' },
  { label: 'PCOS', count: 8, color: '#2ec3b6' },
  { label: 'Insulin Resistance', count: 7, color: '#ff9f43' },
];

export interface AnalyticsQuestionnaireBar {
  label: string;
  percent: number;
  color: string;
}

export const analyticsQuestionnaireCompletion: AnalyticsQuestionnaireBar[] = [
  { label: 'Pre-Consultation', percent: 88, color: '#00bba7' },
  { label: 'Health Profile', percent: 74, color: '#00bba7' },
  { label: 'Clinical Assessment', percent: 62, color: '#ff9f43' },
  { label: '24-hr Dietary Recall', percent: 91, color: '#00bba7' },
];
